'use client';

import {FullPageSpinner} from '@components/Spinner';

export default () => <FullPageSpinner />;
